// extracted by mini-css-extract-plugin
export default {"contactUs":"contactUs_contactUs__C7kIk","contactUs_title":"contactUs_contactUs_title__WJ8Xm","Shimiring":"contactUs_Shimiring__xUTHu"};